import { TechDirectorDashboardNew } from '@/components/dashboard/TechDirectorDashboardNew'
import { EnhancedHomeScreen } from '@/components/EnhancedHomeScreen'
import { CEOBigNumbersDashboard } from '@/components/ceo/CEOBigNumbersDashboard'
import { useAuth } from '@/hooks/useAuth'
import { calculateDashboardVacationAlerts, getRealEmployeeVacationData } from '@/lib/dashboard-utils'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

export const Route = createFileRoute('/_auth/big-numbers')({
  component: DashboardPage,
})

function DashboardPage() {
  const { user } = useAuth()
  const [vacationAlerts, setVacationAlerts] = useState<any[]>([])
  const [isLoadingAlerts, setIsLoadingAlerts] = useState(true)

  // User is guaranteed to exist here due to auth layout
  const isAdmin = user?.role === 'admin'
  const isCEO = user?.role === 'ceo' || user?.role === 'vice-presidente' || user?.role === 'diretor-financeiro'
  const isManager = user?.role === 'diretor-executivo' || user?.role === 'diretor-tecnico'

  // Load vacation alerts asynchronously for regular employees
  useEffect(() => {
    const loadVacationAlerts = async () => {
      try {
        setIsLoadingAlerts(true)
        const realVacationData = await getRealEmployeeVacationData()
        const alerts = calculateDashboardVacationAlerts(realVacationData)
        setVacationAlerts(alerts)
      } catch (error) {
        console.error('Error loading vacation alerts:', error)
      } finally {
        setIsLoadingAlerts(false)
      }
    }

    // Only load for regular employees (managers get their data from EnhancedHomeScreen)
    if (!isManager && !isAdmin) {
      loadVacationAlerts()
    } else {
      setIsLoadingAlerts(false)
    }
  }, [isManager, isAdmin])

  if (!user) {
    return <div>Loading...</div>
  }

  // DEBUG: Log role check for troubleshooting
  console.log('[BigNumbers] user.role:', user.role, '| isCEO:', isCEO)

  // Show CEO Big Numbers Dashboard
  if (isCEO) {
    return <CEOBigNumbersDashboard />
  }

  // Show enhanced home screen for managers
  if (user.role === 'diretor-tecnico') {
    return <TechDirectorDashboardNew />
  }

  if (isManager || isAdmin) {
    return <EnhancedHomeScreen />
  }

  // Regular employee dashboard
  return (
    <div className="space-y-6 sm:space-y-8">
      {/* Header with Welcome Message */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mb-2 bg-gradient-to-r from-white to-brand-gray-light bg-clip-text text-transparent">
            Dashboard
          </h1>
          <p className="font-body text-brand-gray-light">
            Bem-vindo de volta, <span className="text-brand-primary font-medium">{user.name}</span>
          </p>
        </div>
        <div className="mt-4 sm:mt-0">
          <div className="flex items-center space-x-2 text-sm text-brand-gray">
            <div className="w-2 h-2 bg-brand-primary rounded-full animate-pulse"></div>
            <span>Última atualização: agora</span>
          </div>
        </div>
      </div>

      {/* Employee-specific metrics */}
      {/* <div className="dashboard-grid lg:grid-cols-4">
        <MetricCard
          title="Dias de Férias Disponíveis"
          value="15"
          icon={Calendar}
        />
        <MetricCard
          title="Treinamentos Concluídos"
          value="3"
          change="+1 este mês"
          icon={Award}
          trend="up"
        />
        <MetricCard
          title="Banco de Horas"
          value="+8h"
          icon={Clock}
        />
        <MetricCard
          title="Próxima Avaliação"
          value="Mar 2024"
          icon={CheckCircle}
        />
      </div> */}
    </div>
  )
}
